/** Compact choices dispatch the same select change as the right inspector. */
export function installLineStyleChoices(popup: HTMLElement, close: () => void) {
  const source = popup.querySelector<HTMLSelectElement>("select")!;
  source.parentElement!.classList.add("native-choice-source");
  const list = document.createElement("div");
  list.className = "native-line-style-choices";
  for (const [value, label] of [
    ["solid", "Сплошная"],
    ["dashed", "Пунктир"],
    ["dotted", "Точки"],
  ]) {
    const button = document.createElement("button");
    button.type = "button";
    button.dataset.nativeLineStyle = value;
    const sample = document.createElement("span");
    sample.className = "native-line-sample";
    sample.style.borderTopStyle = value!;
    sample.setAttribute("aria-hidden", "true");
    button.append(sample, document.createTextNode(label!));
    button.onclick = () => {
      source.value = value!;
      source.dispatchEvent(new Event("change", { bubbles: true }));
      close();
    };
    list.append(button);
  }
  popup.append(list);
}
